import actions from '@/modules/profile/store/actions'
import getters from '@/modules/profile/store/getters'
import mutations from '@/modules/profile/store/mutations'

export default {
  state: () => ({}),
  actions: actions,
  getters: getters,
  mutations: mutations
}
